import AverageCost from '../bank/averageCost'
import BalanceBreakdownBank from '../bank/balanceBreakdown'
import CashFlow from '../bank/cashFlow'
import DepositAndCredit from '../bank/depositAndCredit'
import EarningBreakdownBank from '../bank/earningBreakdown'
import EarningQuality from '../bank/earningQuality'
import FundingStructure from '../bank/fundingStructure'
import LiquidityBank from '../bank/liquidity'
import LoanBookBreakdown from '../bank/loanBookBreakdown'
import {
  typeComponentBank,
  typeComponentCorporate,
  typeComponentLifeInsurance,
  typeComponentNonBank,
  typeComponentNonLifeInsurance,
  typeComponentSecurity,
  typeViewBy,
} from '../constant'
import AssetManagementEfficiency from '../corporate/assetManagementEfficiency'
import BalanceBreakdown from '../corporate/balanceBreakdown'
import CashBreakdown from '../corporate/cashBreakdown'
import Coverage from '../corporate/coverage'
import { Trend } from '../corporate/earningBreakdown/Trend'
import Liquidity from '../corporate/liquidity'
import Profitability from '../corporate/profitability'
import RoaAndRoe from '../corporate/roaAndRoe'
import Solvency from '../corporate/solvency'
import BalanceBreakdownLifeInsurance from '../lifeInsurance/balanceBreakdown'
import CashFlowLifeInsurance from '../lifeInsurance/cashFlow'
import EarningBreakdownLifeInsurance from '../lifeInsurance/earningBreakdown'
import InsurancePremiumRevenueLifeInsurance from '../lifeInsurance/insurancePremiumRevenue'
import InsuranceSolvencyLifeInsurance from '../lifeInsurance/insuranceSolvency'
import LiquidityLifeInsurance from '../lifeInsurance/liquidity'
import OperationalEfficiencyLifeInsurance from '../lifeInsurance/operationalEfficiency'
import ProfitabilityLifeInsurance from '../lifeInsurance/profitability'
import RoaAndRoeLifeInsurance from '../lifeInsurance/roaAndRoe'
import AverageCostNonBank from '../nonBank/averageCost'
import BalanceBreakdownNonBank from '../nonBank/balanceBreakdown'
import CashFlowNonBank from '../nonBank/cashFlow'
import DepositAndCreditNonBank from '../nonBank/depositAndCredit'
import EarningBreakdownNonBank from '../nonBank/earningBreakdown'
import EarningQualityNonBank from '../nonBank/earningQuality'
import FundingStructureNonBank from '../nonBank/fundingStructure'
import LiquidityNonBank from '../nonBank/liquidity'
import LoanBookBreakdownNonBank from '../nonBank/loanBookBreakdown'
import BalanceBreakdownNonLifeInsurance from '../nonLifeInsurance/balanceBreakdown'
import CashFlowNonLifeInsurance from '../nonLifeInsurance/cashFlow'
import EarningBreakdownNonLifeInsurance from '../nonLifeInsurance/earningBreakdown'
import InsurancePremiumRevenueNonLifeInsurance from '../nonLifeInsurance/insurancePremiumRevenue'
import InsuranceSolvencyNonLifeInsurance from '../nonLifeInsurance/insuranceSolvency'
import LiquidityNonLifeInsurance from '../nonLifeInsurance/liquidity'
import OperationalEfficiencyNonLifeInsurance from '../nonLifeInsurance/operationalEfficiency'
import ProfitabilityNonLifeInsurance from '../nonLifeInsurance/profitability'
import RoaAndRoeNonLifeInsurance from '../nonLifeInsurance/roaAndRoe'
import BalanceBreakdownSecurity from '../security/balanceBreakdown'
import BusinessPosition from '../security/businessPosition'
import CashFlowSecurity from '../security/cashFlow'
import EarningBreakdownSecurity from '../security/earningBreakdown'
import EarningQualitySecurity from '../security/earningQuality'
import FinancialAsset from '../security/financialAsset'
import FundingAndLiquidity from '../security/fundingAndLiquidity'
import OperatingIncome from '../security/operatingIncome'

const getPanelDownload = (type, viewBy, props = {}) => {
  switch (type) {
    // corporate
    case typeComponentCorporate.PROFITABILITY:
      return [typeViewBy.EACH_YEAR, typeViewBy.TREND].includes(viewBy) ? (
        <div style={{ height: 332, width: 600 }}>
          <Profitability isDownloadComponent {...props} />
        </div>
      ) : undefined
    case typeComponentCorporate.ROA_AND_ROE:
      return viewBy === typeViewBy.EACH_YEAR ? (
        <div style={{ height: 332, width: 750 }}>
          <RoaAndRoe {...props} />
        </div>
      ) : undefined
    case typeComponentCorporate.ASSET_MANAGEMENT_EFFICIENCY:
      return [typeViewBy.TREND, typeViewBy.EACH_YEAR].includes(viewBy) ? (
        <div style={{ height: 380, width: 1200 }}>
          <AssetManagementEfficiency isDownloadComponent {...props} />
        </div>
      ) : undefined
    case typeComponentCorporate.LIQUIDITY:
      return viewBy === typeViewBy.EACH_YEAR ? (
        <div style={{ height: 332, width: 600 }}>
          <Liquidity {...props} />
        </div>
      ) : undefined
    case typeComponentCorporate.SOLVENCY:
      return [typeViewBy.EACH_YEAR, typeViewBy.TREND].includes(viewBy) ? (
        <div style={{ height: 332, width: 700 }}>
          <Solvency isDownloadComponent {...props} />
        </div>
      ) : undefined
    case typeComponentCorporate.BALANCE_BREAKDOWN:
      return [typeViewBy.EACH_YEAR, typeViewBy.TREND].includes(viewBy) ? (
        <div
          style={{
            width: viewBy === typeViewBy.EACH_YEAR ? 1024 : 800,
            height: viewBy === typeViewBy.EACH_YEAR ? 350 : 'auto',
          }}
        >
          <BalanceBreakdown isDownloadComponent {...props} />
        </div>
      ) : undefined
    case typeComponentCorporate.COVERAGE:
      return viewBy === typeViewBy.TREND ? (
        <div style={{ width: 1024, height: 420 }}>
          <Coverage isDownloadComponent {...props} />
        </div>
      ) : undefined
    case typeComponentCorporate.EARNING_BREAKDOWN:
      return viewBy === typeViewBy.TREND ? (
        <div style={{ width: 1024, height: 420 }}>
          <Trend isDownloadComponent {...props} />
        </div>
      ) : undefined
    case typeComponentCorporate.CASH_BREAKDOWN:
      return viewBy === typeViewBy.TREND ? (
        <div style={{ width: 1024, height: 420 }}>
          <CashBreakdown isDownloadComponent {...props} />
        </div>
      ) : undefined
    // bank
    case typeComponentBank.LOAN_BOOK_BREAKDOWN:
      return viewBy === typeViewBy.TREND ? (
        <div style={{ width: 580, height: 'auto' }}>
          <LoanBookBreakdown isDownloadComponent {...props} />
        </div>
      ) : undefined
    case typeComponentBank.DEPOSIT_AND_CREDIT:
      return viewBy === typeViewBy.TREND ? (
        <div style={{ width: 1024 }}>
          <DepositAndCredit isDownloadComponent {...props} />
        </div>
      ) : undefined
    case typeComponentBank.BALANCE_BREAKDOWN:
      return [typeViewBy.EACH_YEAR, typeViewBy.TREND].includes(viewBy) ? (
        <div style={{ width: 1024 }}>
          <BalanceBreakdownBank isDownloadComponent {...props} />
        </div>
      ) : undefined
    case typeComponentBank.EARNING_QUALITY:
      return viewBy === typeViewBy.TREND ? (
        <div style={{ width: 1024, height: 580 }}>
          <EarningQuality isDownloadComponent {...props} />
        </div>
      ) : undefined
    case typeComponentBank.LIQUIDITY:
      return viewBy === typeViewBy.TREND ? (
        <div style={{ width: 1024, height: 580 }}>
          <LiquidityBank isDownloadComponent {...props} />
        </div>
      ) : undefined
    case typeComponentBank.AVERAGE_COST:
      return viewBy === typeViewBy.TREND ? (
        <div style={{ width: 1024, height: 580 }}>
          <AverageCost isDownloadComponent {...props} />
        </div>
      ) : undefined
    case typeComponentBank.FUNDING_STRUCTURE:
      return viewBy === typeViewBy.TREND ? (
        <div style={{ width: 1024 }}>
          <FundingStructure isDownloadComponent {...props} />
        </div>
      ) : undefined
    case typeComponentBank.EARNING_BREAKDOWN:
      return viewBy === typeViewBy.TREND ? (
        <div style={{ width: 1024 }}>
          <EarningBreakdownBank isDownloadComponent {...props} />
        </div>
      ) : undefined
    case typeComponentBank.CASH_FLOW:
      return viewBy === typeViewBy.TREND ? (
        <div style={{ width: 1024 }}>
          <CashFlow isDownloadComponent {...props} />
        </div>
      ) : undefined
    // non bank
    case typeComponentNonBank.LOAN_BOOK_BREAKDOWN:
      return viewBy === typeViewBy.TREND ? (
        <div style={{ width: 580, height: 'auto' }}>
          <LoanBookBreakdownNonBank isDownloadComponent {...props} />
        </div>
      ) : undefined
    case typeComponentNonBank.DEPOSIT_AND_CREDIT:
      return viewBy === typeViewBy.TREND ? (
        <div style={{ width: 1024 }}>
          <DepositAndCreditNonBank isDownloadComponent {...props} />
        </div>
      ) : undefined
    case typeComponentNonBank.BALANCE_BREAKDOWN:
      return [typeViewBy.EACH_YEAR, typeViewBy.TREND].includes(viewBy) ? (
        <div style={{ width: 1024 }}>
          <BalanceBreakdownNonBank isDownloadComponent {...props} />
        </div>
      ) : undefined
    case typeComponentNonBank.EARNING_QUALITY:
      return viewBy === typeViewBy.TREND ? (
        <div style={{ width: 1024, height: 580 }}>
          <EarningQualityNonBank isDownloadComponent {...props} />
        </div>
      ) : undefined
    case typeComponentNonBank.LIQUIDITY:
      return viewBy === typeViewBy.TREND ? (
        <div style={{ width: 1024, height: 580 }}>
          <LiquidityNonBank isDownloadComponent {...props} />
        </div>
      ) : undefined
    case typeComponentNonBank.AVERAGE_COST:
      return viewBy === typeViewBy.TREND ? (
        <div style={{ width: 1024, height: 580 }}>
          <AverageCostNonBank isDownloadComponent {...props} />
        </div>
      ) : undefined
    case typeComponentNonBank.FUNDING_STRUCTURE:
      return viewBy === typeViewBy.TREND ? (
        <div style={{ width: 1024 }}>
          <FundingStructureNonBank isDownloadComponent {...props} />
        </div>
      ) : undefined
    case typeComponentNonBank.EARNING_BREAKDOWN:
      return viewBy === typeViewBy.TREND ? (
        <div style={{ width: 1024 }}>
          <EarningBreakdownNonBank isDownloadComponent {...props} />
        </div>
      ) : undefined
    case typeComponentNonBank.CASH_FLOW:
      return viewBy === typeViewBy.TREND ? (
        <div style={{ width: 1024 }}>
          <CashFlowNonBank isDownloadComponent {...props} />
        </div>
      ) : undefined
    // security
    case typeComponentSecurity.OPERATING_INCOME:
      return [typeViewBy.EACH_YEAR, typeViewBy.TREND].includes(viewBy) ? (
        <div
          style={{
            width: 1024,
            height: viewBy === typeViewBy.TREND ? 'auto' : 420,
          }}
        >
          <OperatingIncome isDownloadComponent {...props} />
        </div>
      ) : undefined
    case typeComponentSecurity.BALANCE_BREAKDOWN:
      return [typeViewBy.EACH_YEAR, typeViewBy.TREND].includes(viewBy) ? (
        <div
          style={{
            width: viewBy === typeViewBy.EACH_YEAR ? 1200 : 1024,
            height: viewBy === typeViewBy.EACH_YEAR ? 550 : 'auto',
          }}
        >
          <BalanceBreakdownSecurity isDownloadComponent {...props} />
        </div>
      ) : undefined
    case typeComponentSecurity.BUSINESS_POSITION:
      return viewBy === typeViewBy.TREND ? (
        <div style={{ width: 1024, height: 420 }}>
          <BusinessPosition isDownloadComponent {...props} />
        </div>
      ) : undefined
    case typeComponentSecurity.EARNING_QUALITY:
      return viewBy === typeViewBy.TREND ? (
        <div style={{ width: 1024, height: 420 }}>
          <EarningQualitySecurity isDownloadComponent {...props} />
        </div>
      ) : undefined
    case typeComponentSecurity.FUNDING_AND_LIQUIDITY:
      return viewBy === typeViewBy.TREND ? (
        <div style={{ width: 1024, height: 420 }}>
          <FundingAndLiquidity isDownloadComponent {...props} />
        </div>
      ) : undefined
    case typeComponentSecurity.FINANCIAL_ASSET:
      return viewBy === typeViewBy.TREND ? (
        <div style={{ width: 1024, height: 580 }}>
          <FinancialAsset isDownloadComponent {...props} />
        </div>
      ) : undefined
    case typeComponentSecurity.EARNING_BREAKDOWN:
      return viewBy === typeViewBy.TREND ? (
        <div style={{ width: 1024 }}>
          <EarningBreakdownSecurity isDownloadComponent {...props} />
        </div>
      ) : undefined
    case typeComponentSecurity.CASH_FLOW:
      return viewBy === typeViewBy.TREND ? (
        <div style={{ width: 1024 }}>
          <CashFlowSecurity isDownloadComponent {...props} />
        </div>
      ) : undefined
    // life insurance
    case typeComponentLifeInsurance.INSURANCE_PREMIUM_REVENUE:
      return viewBy === typeViewBy.TREND ? (
        <div style={{ width: 1024 }}>
          <InsurancePremiumRevenueLifeInsurance
            isDownloadComponent
            {...props}
          />
        </div>
      ) : undefined
    case typeComponentLifeInsurance.OPERATIONAL_EFFICIENCY:
      return [typeViewBy.EACH_YEAR, typeViewBy.TREND].includes(viewBy) ? (
        <div style={{ width: 1024, height: 420 }}>
          <OperationalEfficiencyLifeInsurance isDownloadComponent {...props} />
        </div>
      ) : undefined
    case typeComponentLifeInsurance.PROFITABILITY:
      return viewBy === typeViewBy.TREND ? (
        <div style={{ height: 332, width: 600 }}>
          <ProfitabilityLifeInsurance isDownloadComponent {...props} />
        </div>
      ) : undefined
    case typeComponentLifeInsurance.ROA_AND_ROE:
      return viewBy === typeViewBy.EACH_YEAR ? (
        <div style={{ height: 332, width: 750 }}>
          <RoaAndRoeLifeInsurance {...props} />
        </div>
      ) : undefined
    case typeComponentLifeInsurance.INSURANCE_SOLVENCY:
      return viewBy === typeViewBy.TREND ? (
        <div style={{ width: 1024, height: 580 }}>
          <InsuranceSolvencyLifeInsurance isDownloadComponent {...props} />
        </div>
      ) : undefined
    case typeComponentLifeInsurance.LIQUIDITY:
      return viewBy === typeViewBy.EACH_YEAR ? (
        <div style={{ height: 332, width: 600 }}>
          <LiquidityLifeInsurance {...props} />
        </div>
      ) : undefined
    case typeComponentLifeInsurance.BALANCE_BREAKDOWN:
      return [typeViewBy.EACH_YEAR, typeViewBy.TREND].includes(viewBy) ? (
        <div
          style={{
            width: viewBy === typeViewBy.EACH_YEAR ? 1200 : 1024,
            height: viewBy === typeViewBy.EACH_YEAR ? 550 : 'auto',
          }}
        >
          <BalanceBreakdownLifeInsurance isDownloadComponent {...props} />
        </div>
      ) : undefined
    case typeComponentLifeInsurance.EARNING_BREAKDOWN:
      return viewBy === typeViewBy.TREND ? (
        <div style={{ width: 1024 }}>
          <EarningBreakdownLifeInsurance isDownloadComponent {...props} />
        </div>
      ) : undefined
    case typeComponentLifeInsurance.CASH_FLOW:
      return viewBy === typeViewBy.TREND ? (
        <div style={{ width: 1024 }}>
          <CashFlowLifeInsurance isDownloadComponent {...props} />
        </div>
      ) : undefined
    // non life insurance
    case typeComponentNonLifeInsurance.INSURANCE_PREMIUM_REVENUE:
      return viewBy === typeViewBy.TREND ? (
        <div style={{ width: 1024 }}>
          <InsurancePremiumRevenueNonLifeInsurance
            isDownloadComponent
            {...props}
          />
        </div>
      ) : undefined
    case typeComponentNonLifeInsurance.OPERATIONAL_EFFICIENCY:
      return [typeViewBy.EACH_YEAR, typeViewBy.TREND].includes(viewBy) ? (
        <div style={{ width: 1024, height: 420 }}>
          <OperationalEfficiencyNonLifeInsurance
            isDownloadComponent
            {...props}
          />
        </div>
      ) : undefined
    case typeComponentNonLifeInsurance.PROFITABILITY:
      return viewBy === typeViewBy.TREND ? (
        <div style={{ height: 332, width: 600 }}>
          <ProfitabilityNonLifeInsurance isDownloadComponent {...props} />
        </div>
      ) : undefined
    case typeComponentNonLifeInsurance.ROA_AND_ROE:
      return viewBy === typeViewBy.EACH_YEAR ? (
        <div style={{ height: 332, width: 750 }}>
          <RoaAndRoeNonLifeInsurance {...props} />
        </div>
      ) : undefined
    case typeComponentNonLifeInsurance.INSURANCE_SOLVENCY:
      return viewBy === typeViewBy.TREND ? (
        <div style={{ width: 1024, height: 580 }}>
          <InsuranceSolvencyNonLifeInsurance isDownloadComponent {...props} />
        </div>
      ) : undefined
    case typeComponentNonLifeInsurance.LIQUIDITY:
      return viewBy === typeViewBy.EACH_YEAR ? (
        <div style={{ height: 332, width: 600 }}>
          <LiquidityNonLifeInsurance {...props} />
        </div>
      ) : undefined
    case typeComponentNonLifeInsurance.BALANCE_BREAKDOWN:
      return [typeViewBy.EACH_YEAR, typeViewBy.TREND].includes(viewBy) ? (
        <div
          style={{
            width: viewBy === typeViewBy.EACH_YEAR ? 1200 : 1024,
            height: viewBy === typeViewBy.EACH_YEAR ? 550 : 'auto',
          }}
        >
          <BalanceBreakdownNonLifeInsurance isDownloadComponent {...props} />
        </div>
      ) : undefined
    case typeComponentNonLifeInsurance.EARNING_BREAKDOWN:
      return viewBy === typeViewBy.TREND ? (
        <div style={{ width: 1024 }}>
          <EarningBreakdownNonLifeInsurance isDownloadComponent {...props} />
        </div>
      ) : undefined
    case typeComponentNonLifeInsurance.CASH_FLOW:
      return viewBy === typeViewBy.TREND ? (
        <div style={{ width: 1024 }}>
          <CashFlowNonLifeInsurance isDownloadComponent {...props} />
        </div>
      ) : undefined
    default:
      return undefined
  }
}

export default getPanelDownload
